
import { BookingProvider } from './components/context/BookingContext';
import './styles/variables.css';
import './App.css'
import { BrowserRouter as Router } from 'react-router-dom';
import RoutesConfig from './routers'
import { useEffect } from 'react';
import { Request } from './helpers/Request';
import useTelegramInitData from './helpers/useTelegramInitData';

function App() {
  const { initData } = useTelegramInitData();

  useEffect(() => {
    // Автоматическая регистрация при наличии данных пользователя
    if (initData?.user) {
      Request({
        method: 'GET',
        url: '/me',
      }).then(({ error }) => {
        if (error) console.error('Ошибка регистрации:', error);
      });
    }
  }, [initData]);

  return (
    <BookingProvider>
      <Router>
        <RoutesConfig />
      </Router>
    </BookingProvider>
  )
}

export default App
